import { Group, Stack } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';
import { $enum } from 'ts-enum-util';

import { EnrollmentReviewCard } from '../../EnrollmentReviewCard';
import { EnrollmentAction } from '../EmployeePageHeader';
import { getReviewCardVisibility } from './EmployeePageContentUtils';
import {
  EmployeeActivityLogTab,
  EmployeePageFiles,
  EmployeePageMembers,
  EmployeePagePlans,
  EmployeePageTabType,
  EmployeePageTabs,
  EmployeePaymentsTab,
} from './EmployeePageTabs';
import { EnrollmentOverviewCard } from './EnrollmentOverview';

type Props = {
  onEnrollmentTabActionChange: (action?: EnrollmentAction) => void;
  onboardingPeriodId: string;
  tab: EmployeePageTabType;
  employerId: string;
  employeeId: string;
  isDon: boolean;
};

export const EmployeePageContent = ({
  onEnrollmentTabActionChange,
  onboardingPeriodId,
  employerId,
  employeeId,
  isDon,
  tab,
}: Props) => {
  const { data: onboardingPeriod } = useMonolithQuery({
    method: 'onboardingPeriodReportsControllerGenerateOnboardingPeriodReport',
    params: [onboardingPeriodId],
  });

  const withReviewCard =
    onboardingPeriod &&
    getReviewCardVisibility(onboardingPeriod.enrollmentStatus);

  return (
    <Group gap="var(--space-40)" wrap="nowrap" align="start">
      <Stack w="100%" style={{ flexShrink: 2 }}>
        <EmployeePageTabs
          onboardingPeriodId={onboardingPeriodId}
          employerId={employerId}
          employeeId={employeeId}
          isDon={isDon}
          tab={tab}
        />
        {$enum.mapValue(tab).with({
          [EmployeePageTabType.PLANS]: (
            <EmployeePagePlans
              onEnrollmentTabActionChange={onEnrollmentTabActionChange}
              onboardingPeriodId={onboardingPeriodId}
              employerId={employerId}
              employeeId={employeeId}
              isDon={isDon}
            />
          ),
          [EmployeePageTabType.ACTIVITY_LOG]: (
            <EmployeeActivityLogTab
              onboardingPeriodId={onboardingPeriodId}
              isDon={isDon}
            />
          ),
          [EmployeePageTabType.MEMBERS]: (
            <EmployeePageMembers
              onboardingPeriodId={onboardingPeriodId}
              employerId={employerId}
              employeeId={employeeId}
            />
          ),
          [EmployeePageTabType.ZORRO_PAY]: (
            <EmployeePaymentsTab
              onboardingPeriodId={onboardingPeriodId}
              employeeId={employeeId}
              employerId={employerId}
              isDon={isDon}
              onEnrollmentTabActionChange={onEnrollmentTabActionChange}
            />
          ),
          [EmployeePageTabType.FILES]: (
            <EmployeePageFiles
              onboardingPeriodId={onboardingPeriodId}
              employeeId={employeeId}
              employerId={employerId}
              isDon={isDon}
            />
          ),
        })}
      </Stack>
      <Stack maw="21.875rem" miw="18rem">
        <EnrollmentOverviewCard
          employeeId={employeeId}
          onboardingPeriodId={onboardingPeriodId}
        />
        {withReviewCard && (
          <EnrollmentReviewCard
            employeeId={employeeId}
            onboardingPeriodId={onboardingPeriodId}
            withOnboardingAllowance
          />
        )}
      </Stack>
    </Group>
  );
};
